// extracted by mini-css-extract-plugin
module.exports = {"root":"Markdown_root__8aH8C","useFade-fadeIn":"Markdown_useFade-fadeIn__NYIXL","useFade-fadeOut":"Markdown_useFade-fadeOut__G72Ks"};